
import Button from '../../../components/base/Button';

export default function FactorySection() {
  const values = [
    {
      title: '南滇严选背书',
      subtitle: '严格品控标准，权威质量认证',
      icon: 'ri-shield-check-line',
      color: 'from-blue-500 to-blue-600',
      details: [
        '20+项质量检测标准',
        '专业品控团队把关',
        '权威机构认证背书',
        '全程质量追溯体系'
      ]
    },
    {
      title: '渠道覆盖',
      subtitle: '多渠道分发，最大化销售机会',
      icon: 'ri-global-line',
      color: 'from-slate-500 to-slate-600',
      details: [
        '2000+头部主播资源',
        '私域流量精准投放',
        '跨境电商全球销售',
        '线下渠道深度合作'
      ]
    },
    {
      title: '技术赋能',
      subtitle: '专利技术开放，共享创新成果',
      icon: 'ri-lightbulb-line',
      color: 'from-blue-400 to-blue-500',
      details: [
        '年份茶检测专利技术',
        '溯源技术系统支持',
        '智能仓储管理系统',
        '数据分析决策支持'
      ]
    }
  ];

  const developmentCases = [
    {
      title: '定制联名款',
      description: '与头部主播联合开发专属产品',
      image: 'https://public.readdy.ai/ai/img_res/751977d60230d110b4f63168550dc7f8.jpg'
    },
    {
      title: '渠道专供款',
      description: '针对不同渠道特性定制产品',
      image: 'https://readdy.ai/api/search-image?query=Exclusive%20tea%20products%20designed%20for%20different%20sales%20channels%2C%20various%20premium%20tea%20packaging%20designs%2C%20e-commerce%20optimized%20product%20presentation%2C%20professional%20commercial%20photography%2C%20clean%20organized%20display%2C%20modern%20packaging%20design%2C%20high-quality%20tea%20products&width=400&height=300&seq=collab2&orientation=landscape'
    },
    {
      title: '节日限定款',
      description: '结合节庆热点打造爆款产品',
      image: 'https://readdy.ai/api/search-image?query=Limited%20edition%20festival%20tea%20packaging%20with%20traditional%20Chinese%20elements%2C%20seasonal%20holiday%20themed%20tea%20products%2C%20festive%20red%20and%20gold%20color%20scheme%2C%20premium%20gift%20packaging%20design%2C%20celebration%20themed%20tea%20presentation%2C%20elegant%20traditional%20patterns&width=400&height=300&seq=collab3&orientation=landscape'
    }
  ];

  return (
    <section id="factory" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            携手实力工厂，共享千亿渠道
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            为工厂提供全方位合作价值，从品质背书到渠道赋能，助力品牌腾飞
          </p>
        </div>

        {/* Cooperation Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-gray-100 hover:transform hover:scale-105"
            >
              <div className={`w-16 h-16 mb-6 rounded-2xl bg-gradient-to-r ${value.color} flex items-center justify-center`}>
                <i className={`${value.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">{value.title}</h3>
              <p className="text-sm md:text-base text-blue-600 font-medium mb-6">{value.subtitle}</p>
              <div className="space-y-3">
                {value.details.map((detail, detailIndex) => (
                  <div key={detailIndex} className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                    <span className="text-gray-600 text-xs md:text-sm leading-relaxed">{detail}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Development Cases */}
        <div className="bg-gradient-to-r from-blue-50 to-slate-50 rounded-2xl p-8">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-8 text-center">
            联合开发成功案例
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {developmentCases.map((case_, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105"
              >
                <img
                  src={case_.image}
                  alt={case_.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h4 className="text-base md:text-lg font-bold text-gray-800 mb-2">{case_.title}</h4>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">{case_.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
          <h3 className="text-xl md:text-2xl font-bold mb-4">准备好开启合作了吗？</h3>
          <p className="text-sm md:text-base text-blue-100 mb-6 max-w-2xl mx-auto">
            加入南滇古茶供应链生态，与500+优质工厂一起，共享2000+头部主播渠道资源
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="secondary" size="lg">
              工厂合作申请
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-blue-600"
            >
              预约参观考察
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
